export default "__VITE_ASSET__C6q8pkkm__"